import { PageContainer } from "#pages/PageContainer";
import { Box, styled } from "@mui/material";
import { useAppDispatch, useAppSelector } from "store";
import * as React from "react";
import { useParams } from "react-router";
import { Routes } from "#/config";
import { selectActionById } from "#selectors";
import { Optional } from "#types";
import { Action } from "#services/pilotService/types";
import { ActionViewIo } from "#pages/action-page/ActionView";
import { IoState } from "#store/types";
import { fetchActionFromServerAndSetAsCurrent } from "#store/actions";

export const ContentBox = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(2),
}));

export const Item = styled(Box)(({ theme }) => ({ padding: theme.spacing(1) }));

type ResultsPageRouteMatchProps = {
    id: string;
};

export const ActionPage = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(fetchActionFromServerAndSetAsCurrent(Number(id)));
    }, [id]);

    const action: Optional<IoState<Action>> = useAppSelector(state =>
        selectActionById(state, Number(id))
    );

    return (
        <PageContainer>
            <ActionViewIo iostate={action} />
        </PageContainer>
    );
};
